import React, { createContext, useState, useEffect } from "react"
import useFirebase from "src/hooks/useFirebase"

import AddNewBooking from "src/context/utils/user/add-new-booking"
import UpdateExistingBooking from "src/context/utils/user/update-existing-booking"
import SignIn from "src/context/utils/user/sign-in"
import SignOut from "src/context/utils/user/sign-out"
import CheckEmail from "src/context/utils/user/check-email"
import OnAuthStateChange from "src/context/utils/user/on-auth-state-change"
import IsAuthenticatedLocally from "src/context/utils/user/is-authenticated-locally"
import { GetBookings } from 'src/context/utils/user/get-bookings'

const UserContext = createContext({})

const UserProvider = ( { children } ) => {
  const firebase = useFirebase()

  const [ authUser, setAuthUser ] = useState( null )
  const [ user, setUser ] = useState( null )
  const [ cart, setCart ] = useState( [] )
  const isBrowser = () => typeof window !== "undefined"

  const getBookings = user => GetBookings( firebase, user )
  const addNewBooking = ( values, cartData, locations, dateTimes ) => AddNewBooking( firebase, values, cartData, locations, dateTimes, user, authUser )
  const updateExistingBooking = ( values, cartData, locations, dateTimes ) => UpdateExistingBooking( firebase, values, cartData, locations, dateTimes, user, authUser )

  const signIn = ( { email, password } ) => SignIn( firebase, email, password, setUser, setAuthUser )
  const signOut = () => SignOut( firebase, setUser, setAuthUser )

  const onAuthStateChange = React.useCallback( () => OnAuthStateChange(
    firebase, setUser, setAuthUser, setCart
  ), [ firebase, setUser, setAuthUser, setCart ] )

  const isAuthenticatedLocally = () => IsAuthenticatedLocally( isBrowser )
  const checkEmail = ( email ) => CheckEmail( firebase, email )

  useEffect( () => {
    if ( firebase ) {
      const unsubscribe = onAuthStateChange()
      return () => {
        unsubscribe()
      }
    }
  }, [ firebase, onAuthStateChange ] )

  return (
    <UserContext.Provider
      value={{
        addNewBooking,
        updateExistingBooking,
        signIn,
        signOut,
        checkEmail,
        getBookings,
        setCart,
        authUser,
        user,
        cart,
        isBrowser,
        isAuthenticatedLocally,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}
export { UserContext, UserProvider }
